export function getConfig() {
  return {
    api_baseurl: process.env.REACT_APP_API_BASE_URL || '/api',
  };
}
